import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './negativeIVFCycleAnalysis.scss';

export default function NegativeIVFCycleAnalysis(props) {
  const [showTables, setShowTables] = useState({
    oocyteEmbryoOutcome: true
  });
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [oocyteEmbryoOutcomeRows, setOocyteEmbryoOutcomeRows] = useState([
    {parameter: 'No. of COCs Retrieved', value: ''},
    {parameter: 'MII Oocytes', value: ''},
    {parameter: 'Fertilized (Day 1)', value: ''},
    {parameter: 'Cleaved (Day 3)', value: ''},
    {parameter: 'Blastocysts (Day 5/6)', value: ''},
    {parameter: 'Embryo Quality', value: ''}
  ]);

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleTableRowsChange = (id, updatedRows) => {
    if (id === 'oocyteEmbryoOutcome') {
      setOocyteEmbryoOutcomeRows(updatedRows);
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('negativeIVFCycleAnalysisReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Negative IVF Cycle Analysis'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='NegativeIVFCycleAnalysisTemplate'>
      <div className='NegativeIVFCycleAnalysisTemplate'>
        <div style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>NEGATIVE IVF CYCLE ANALYSIS – ASCAS FERTILITY UNIT</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <h4>INDICATIONS:</h4>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Female:' name='femaleIndications' value={formData.femaleIndications} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Male:' name='maleIndications' value={formData.maleIndications} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <h4>🩺 STIMULATION DETAILS:</h4>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='PROTOCOL'
                name='protocol'
                value={formData.protocol}
                options={[
                  {label: 'AGOIST', value: 'AGOIST'},
                  {label: 'ANTAGONIST', value: 'ANTAGONIST'},
                  {label: 'STOP ANTAGONIST', value: 'STOP ANTAGONIST'},
                  {label: 'PPOS', value: 'PPOS'},
                  {label: 'DUAL', value: 'DUAL'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Duration:' name='duration' value={formData.duration} required={false} onChange={handleChange} inputClassName='show' endLabel='days' />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Injections Used'
                name='injectionsUsed'
                value={formData.injectionsUsed}
                options={[
                  {label: 'HMG', value: 'HMG'},
                  {label: 'RFSH', value: 'RFSH'},
                  {label: 'HMG+RFSH', value: 'HMG+RFSH'},
                  {label: 'RLH+RFSH', value: 'RLH+RFSH'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Dosage Hmg:' name='dosageHmg' value={formData.dosageHmg} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Rfs:' name='dosageRfs' value={formData.dosageRfs} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='RFSH+RLH:' name='dosageRfshRlh' value={formData.dosageRfshRlh} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Response FORT:' name='responseFort' value={formData.responseFort} required={false} onChange={handleChange} inputClassName='show' minWidth='160px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='FOI:' name='responseFoi' value={formData.responseFoi} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          {showTables.oocyteEmbryoOutcome && (
            <TemplateTable
              id='oocyteEmbryoOutcome'
              title='OOCYTE & EMBRYO OUTCOME:'
              headers={[
                {key: 'parameter', label: 'Parameter'},
                {key: 'value', label: 'Value'}
              ]}
              rows={oocyteEmbryoOutcomeRows}
              onRowsChange={handleTableRowsChange}
              enableActions={true}
              onNill={() => handleNill('oocyteEmbryoOutcome', setShowTables)}
            />
          )}

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='pgtDetails' className='fw-bold' style={{width: '180px'}}>
              PGT IF DONE DETAILS:
            </label>
            <textarea className='Textarea' placeholder='PGT IF DONE DETAILS' id='pgtDetails' name='pgtDetails' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>

          <h4>SPERM SELECTION:</h4>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Sperm Selection:'
                name='spermSelection'
                value={formData.spermSelection}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                placeholder='Conventional / MF / PICSI / MACS'
                minWidth='180px'
              />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='DNA Fragmentation Index (DFI):' name='dfi' value={formData.dfi} required={false} onChange={handleChange} inputClassName='show' minWidth='300px' />
            </div>
          </div>
          <h4>Karyotyping:</h4>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Male'
                name='karyotypingMale'
                value={formData.karyotypingMale}
                options={[
                  {label: 'Done', value: 'Done'},
                  {label: 'Not Done', value: 'Not Done'},
                  {label: 'Normal', value: 'Normal'},
                  {label: 'Abnormal', value: 'Abnormal'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-6'>
              <SelectField
                label='Female'
                name='karyotypingFemale'
                value={formData.karyotypingFemale}
                options={[
                  {label: 'Done', value: 'Done'},
                  {label: 'Not Done', value: 'Not Done'},
                  {label: 'Normal', value: 'Normal'},
                  {label: 'Abnormal', value: 'Abnormal'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <h4 className='mt-3'>FROZEN EMBRYO TRANSFER (FET):</h4>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Protocol:'
                name='fetProtocol'
                value={formData.fetProtocol}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                placeholder='e.g., HRT / Modified Natural / Letrozole/SC FET'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='ET Thickness at Transfer:'
                name='etThickness'
                value={formData.etThickness}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='mm'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='No. of Embryos Transferred:'
                name='embryosTransferred'
                value={formData.embryosTransferred}
                required={false}
                onChange={handleChange}
                inputClassName='show'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Embryos Remaining:' name='embryosRemaining' value={formData.embryosRemaining} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <h4 className='mt-3'>🧾 CLINICAL COMMENTS</h4>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Cycle Outcome'
                name='cycleOutcome'
                value={formData.cycleOutcome}
                options={[
                  {label: 'Biochemical', value: 'Biochemical'},
                  {label: 'No implantation', value: 'No implantation'},
                  {label: 'Miscarriage', value: 'Miscarriage'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Key Concern:' name='keyConcern' value={formData.keyConcern} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <h4>🔍 RECOMMENDATIONS & NEXT STEPS</h4>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='recommendations' className='fw-bold' style={{width: '180px'}}>
              RECOMMENDATIONS:
            </label>
            <textarea className='Textarea' placeholder='RECOMMENDATIONS & NEXT STEPS' id='recommendations' name='recommendations' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>

          <h4>📋 INVESTIGATIONS BEFORE NEXT CYCLE</h4>
          <div className='row'>
            <div className='col-md-6'>
              <div className='d-flex align-items-start py-2'>
                <label htmlFor='investigationsFemale' className='fw-bold' style={{width: '180px'}}>
                  Female (Wife):
                </label>
                <textarea className='Textarea' placeholder='INVESTIGATIONS FOR FEMALE' id='investigationsFemale' name='investigationsFemale' onChange={handleChange} rows='3' cols='50'></textarea>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='d-flex align-items-start py-2'>
                <label htmlFor='investigationsMale' className='fw-bold' style={{width: '180px'}}>
                  Male (Husband):
                </label>
                <textarea className='Textarea' placeholder='INVESTIGATIONS FOR MALE' id='investigationsMale' name='investigationsMale' onChange={handleChange} rows='3' cols='50'></textarea>
              </div>
            </div>
          </div>

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
              ADVICE:
            </label>
            <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>
          <p className='pt-3' style={{fontWeight: '600'}}>
            Note: Patient encouraged to review expectations, treatment burden, and explore psychological support if needed.
          </p>
        </div>
        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='negativeIVFCycleAnalysisReport'>
        <div id='negativeIVFCycleAnalysisReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>NEGATIVE IVF CYCLE ANALYSIS – ASCAS FERTILITY UNIT</h4>
          </div>
          <div style={{fontWeight: 'bold'}}>INDICATIONS:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Female:', formData.femaleIndications)}
            {renderReportfield('Male:', formData.maleIndications)}
          </div>
          <div style={{fontWeight: 'bold'}}>🩺 STIMULATION DETAILS:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('PROTOCOL:', formData.protocol)}
            {renderReportfield('Duration:', `${formData.duration || ''} days`)}
            {renderReportfield('Injections Used:', formData.injectionsUsed)}
            {renderReportfield('Dosage Hmg:', formData.dosageHmg)}
            {renderReportfield('Rfs:', formData.dosageRfs)}
            {renderReportfield('RFSH+RLH:', formData.dosageRfshRlh)}
            {renderReportfield('Response FORT:', formData.responseFort)}
            {renderReportfield('FOI:', formData.responseFoi)}
          </div>
          {showTables.oocyteEmbryoOutcome && renderDynamicTable('OOCYTE & EMBRYO OUTCOME:', ['Parameter', 'Value'], ['parameter', 'value'], oocyteEmbryoOutcomeRows)}
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('PGT IF DONE DETAILS:', formData.pgtDetails)}</div>
          <div style={{fontWeight: 'bold'}}>SPERM SELECTION:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Sperm Selection:', formData.spermSelection)}
            {renderReportfield('DNA Fragmentation Index (DFI):', formData.dfi)}
          </div>
          <div style={{fontWeight: 'bold'}}>Karyotyping:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Male:', formData.karyotypingMale)}
            {renderReportfield('Female:', formData.karyotypingFemale)}
          </div>
          <div style={{fontWeight: 'bold'}}>FROZEN EMBRYO TRANSFER (FET):</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Protocol:', formData.fetProtocol)}
            {renderReportfield('ET Thickness at Transfer:', `${formData.etThickness || ''} mm`)}
            {renderReportfield('No. of Embryos Transferred:', formData.embryosTransferred)}
            {renderReportfield('Embryos Remaining:', formData.embryosRemaining)}
          </div>
          <div style={{fontWeight: 'bold'}}>🧾 CLINICAL COMMENTS</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Cycle Outcome:', formData.cycleOutcome)}
            {renderReportfield('Key Concern:', formData.keyConcern)}
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('🔍 RECOMMENDATIONS & NEXT STEPS:', formData.recommendations)}</div>
          <div style={{fontWeight: 'bold'}}>📋 INVESTIGATIONS BEFORE NEXT CYCLE</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Female (Wife):', formData.investigationsFemale)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Male (Husband):', formData.investigationsMale)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('ADVICE:', formData.advice)}</div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>Note: Patient encouraged to review expectations, treatment burden, and explore psychological support if needed.</div>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
